export const upLoadImg = {
  data(){

    return {

      //上传头
      headers: {
        Authorization: localStorage.Authorization || ''
      },
      imgList: [], // {name,url} 初始化上传的图片
      uploadImgList: [], // 上传后的图片集合
      uploadImgList1:[],
      uploadImgList2:[],
      uploadImgList3:[],
      uploadImgList4:[],
      uploadImgList5:[]
    }
  },
  methods: {
    // 删除 返回LIST
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.uploadImgList = fileList
      this.emitChange();
    },
    handleRemove1(file, fileList) {
      console.log(file, fileList);
      this.uploadImgList1 = fileList
      this.emitChange();
    },
    handleRemove2(file, fileList) {
      console.log(file, fileList);
      this.uploadImgList2 = fileList
      this.emitChange();
    },
    handleRemove3(file, fileList) {
      console.log(file, fileList);
      this.uploadImgList3 = fileList
      this.emitChange();
    },
    handleRemove4(file, fileList) {
      console.log(file, fileList);
      this.uploadImgList4 = fileList
      this.emitChange();
    },
    handleRemove5(file, fileList) {
      console.log(file, fileList);
      this.uploadImgList5 = fileList
      this.emitChange();
    },
    handlePreview(file) {
      console.log(file);
    },
    // 上传成功  返回 LIST
    uploadSuccess(response, file, fileList){
      console.log(fileList,'图片上传成功')
      this.uploadImgList = fileList
      this.emitChange();

    },
    uploadSuccess1(response, file, fileList){
      this.uploadImgList1 = fileList
      this.emitChange();
    },
    uploadSuccess2(response, file, fileList){
      console.log(fileList)
      this.uploadImgList2 = fileList
      this.emitChange();
    },
    uploadSuccess3(response, file, fileList){
      console.log(fileList)
      this.uploadImgList3 = fileList
      this.emitChange();
    },
    uploadSuccess4(response, file, fileList){
      console.log(fileList)
      this.uploadImgList4 = fileList
      this.emitChange();
    },
    uploadSuccess5(response, file, fileList){
      console.log(fileList)
      this.uploadImgList5 = fileList
      this.emitChange();
    },
    uploadError(response, file, fileList){
      this.$notify({
          title: '失败',
          message: '图片上传失败,请重试',
          type: 'error'
      });
    },
    uploadExc(response, file, fileList){
      this.$notify({
          title: '失败',
          message: '不能继续上传,超出上限数量',
          type: 'error'
      });
    },
    emitChange() {
      try {
        this.$refs.upload.$emit('el.form.change');
      }catch(e) {

      }
    },
      // 初始化图片
    getImgList (imgList,fuckdouhao=',',imgBox='uploadImgList') {
      if (imgList&&imgList.length > 0) {
        let list = imgList.split(fuckdouhao)

        list.filter(item => {
          /**
           * [name description]
           * @params {uploadImgList} 储存 图片相关数据 （初始化 添加 删除）
           * @query {upLoadUrl}   自定义初始化的KEY
           */

           if(/upaiyun/.test(item)){
             this[imgBox].push({name: '', url:item,upLoadUrl:item})
           }else if(/cdn1.yxvzb.com/.test(item)||/http/.test(item)){
             this[imgBox].push({name: '', url:item,upLoadUrl:item})
           }else{
             this[imgBox].push({name: '', url:`${this.$qiniuPath}/${item}`,upLoadUrl:item})
           }

        })
      }
    }
  },
  created() {

  }
}
